/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityProcessResponse
 */
export interface MonitEntityProcessResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityProcessResponse
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityProcessResponse
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityProcessResponse
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityProcessResponse
     */
    process_id?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityProcessResponse
     */
    created?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityProcessResponse
     */
    updated?: number;
}

/**
 * Check if a given object implements the MonitEntityProcessResponse interface.
 */
export function instanceOfMonitEntityProcessResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityProcessResponseFromJSON(json: any): MonitEntityProcessResponse {
    return MonitEntityProcessResponseFromJSONTyped(json, false);
}

export function MonitEntityProcessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityProcessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function MonitEntityProcessResponseToJSON(value?: MonitEntityProcessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'process_id': value.process_id,
        'created': value.created,
        'updated': value.updated,
    };
}

